import { __decorate } from "tslib";
import { Component, Mixins, Prop } from 'vue-property-decorator';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import SubmissionsManager from '@/components/v2/store_add_ons/SubmissionsManager.vue';
import RebateDetails from '@/components/v2/store_add_ons/RebateDetails.vue';
let SubmissionsByStatus = class SubmissionsByStatus extends Mixins(ViewportSizeMixin) {
    pageTitle(status, totalCount) {
        const formattedStatus = status.replace('_', ' ');
        return `${formattedStatus} Rebates ${totalCount}`;
    }
    displayOption(totalCount) {
        if (totalCount > 0) {
            return 'xs7';
        }
        return 'xs12';
    }
    get headers() {
        return [
            {
                text: 'SUBMISSION ID',
                value: 'id',
                align: 'left',
                sortable: false,
            },
            {
                text: 'DATE SUBMITTED',
                value: 'createdAt',
                align: 'left',
                sortable: false,
            },
            {
                text: 'CUSTOMER',
                value: 'customerName',
                align: 'left',
                sortable: false,
            },
            {
                text: 'TOTAL AMOUNT IN RECEIPT',
                value: 'totalAmount',
                align: 'left',
                sortable: false,
            },
        ];
    }
};
__decorate([
    Prop({ type: String, required: true })
], SubmissionsByStatus.prototype, "status", void 0);
SubmissionsByStatus = __decorate([
    Component({
        components: {
            SubmissionsManager,
            RebateDetails,
        },
    })
], SubmissionsByStatus);
export default SubmissionsByStatus;
